<script setup>
  const { from, to } = defineProps({ from: { type: Number, default: 1 }, to: { type: Number, default: 12 } });
</script>

<!----------------------------------------------------------------------------->

<template>
  <div :style="{ 'grid-column': `${from} / ${to + 1}` }"><slot /></div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped></style>
